module.exports = __webpack_public_path__ + "img/my-story-figueira.9cd97a91.jpg";